import Link from 'next/link'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import Trans from 'next-translate/Trans'
import { getGroups } from 'SRC/modules/groups/selectors'
import { getUserTypes } from 'SRC/modules/common/selectors'
import { connect } from 'react-redux'
import ReactSVG from 'react-svg'

const ADDRESS_LINES = [
  'Jovana Tomaševića 1,',
  'Bar, 85000',
  'Crna Gora',
  'PIB: 03007448'
]

const CONTACT_LINKS = [
  { label: '+382 (0) 67 312 555', href: 'tel:+38267312555' },
  { label: '+382 (0) 30 550 099', href: 'tel:+38230550099' },
  { label: 'info@autodiler.me', href: 'mailto:info@autodiler.me' }
]


import translations from '../../../../../../public/data/translations.json'

const FooterNew = ({ groups, userTypes }) => {
  const { t, lang } = useTranslation('common')

  const locale = lang?.toUpperCase() || 'ME'

  return (
    <footer className='footer-new'>
      <div className='footer-new__inner'>
        <div className='footer-new__column footer-new__column--links'>
          <p className='footer-new__title footer-new__title--links'>{t(`footer_column1_title`)}</p>

          <ul className='footer-new__links'>
            {(groups || []).map((group) => (
              <li key={group.id} className='footer-new__links-item'>
                <Link
                  href={{ pathname: '/category', query: { category: group.seo } }}
                  as={`/${group.seo}`}
                >
                  <a className='footer-new__link'>
                    {t(`footer_column1_${group.id}_title`)}
                  </a>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className='footer-new__column footer-new__column--links-2'>
          <p className='footer-new__title footer-new__title--links-2'>{t(`footer_column2_title`)}</p>
          <ul className='footer-new__links'>
            <li key='login' className='footer-new__links-item'>
              <Link
                href={{
                  pathname: '/profile',
                }}
                as='/profil'
              >
                <a className='footer-new__link'>
                  {t('footer_column3_21_title')}
                </a>
              </Link>
            </li>

            <li key='contact' className='footer-new__links-item'>
              <a className='footer-new__link' href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale].kontakt.slug}`}>
                {translations.staticPages[locale].kontakt.title}
              </a>
            </li>

            <li key='pomoc' className='footer-new__links-item'>
              <a className='footer-new__link' href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale].pomoc.slug}`}>
                {translations.staticPages[locale].pomoc.title}
              </a>
            </li>

            <li key='uslovi-koriscenja' className='footer-new__links-item'>
              <a className='footer-new__link' href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale]['uslovi-koriscenja'].slug}`}>
                {translations.staticPages[locale]['uslovi-koriscenja'].title}
              </a>
            </li>

            <li key='politika-privatnosti' className='footer-new__links-item'>
              <a className='footer-new__link' href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale]['politika-privatnosti'].slug}`}>
                {translations.staticPages[locale]['politika-privatnosti'].title}
              </a>
            </li>

            <li key='prava-potrosaca' className='footer-new__links-item'>
              <a className='footer-new__link' href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale]['prava-potrosaca'].slug}`}>
                {translations.staticPages[locale]['prava-potrosaca'].title}
              </a>
            </li>

            <li key='sigurna-trgovina' className='footer-new__links-item'>
              <a className='footer-new__link' href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale]['sigurna-trgovina'].slug}`}>
                {translations.staticPages[locale]['sigurna-trgovina'].title}
              </a>
            </li>
          </ul>
        </div>

        <div className='footer-new__column footer-new__column--logo'>
          <ReactSVG
            src={'/icons/footer-logo.svg'}
            beforeInjection={svg => {
              svg.setAttribute('style', 'width: 250px; height: 200px;')
            }}
            wrapper='span'
          />
        </div>

        <div className='footer-new__column footer-new__column--company'>
          <p className='footer-new__title footer-new__title--company'>Weblab D.O.O.</p>
          <div className='footer-new__details'>
            {ADDRESS_LINES.map(line => (
              <p key={line} className='footer-new__text'>{line}</p>
            ))}
          </div>

          <div className='footer-new__contact'>
            {CONTACT_LINKS.map(contact => (
              <a key={contact.label} className='footer-new__contact-link' href={contact.href}>
                {contact.label}
              </a>
            ))}
          </div>

          <div className='footer-new__social'>
            <a
              key={'Facebook'}
              href={'https://www.facebook.com/autodiler.me'}
              target='_blank' rel='noreferrer'
              aria-label={'Facebook'}
            >
              <ReactSVG
                src={'/icons/social-fb.svg'}
                beforeInjection={svg => {
                }}
                wrapper='span'
              />
            </a>
            <a
              key={'Instagram'}
              href={'https://www.instagram.com/autodiler_official'}
              target='_blank' rel='noreferrer'
              aria-label={'Instagram'}
            >
              <ReactSVG
                src={'/icons/social-instagram.svg'}
                beforeInjection={svg => {
                }}
                wrapper='span'
              />
            </a>
            <a
              key={'Tiktok'}
              href={'https://www.tiktok.com/@autodiler'}
              target='_blank' rel='noreferrer'
              aria-label={'Tiktok'}
            >
              <ReactSVG
                src={'/icons/social-tiktok.svg'}
                beforeInjection={svg => {
                }}
                wrapper='span'
              />
            </a>
          </div>
        </div>

        <div className='footer-new__column footer-new__column--app-links'>
          <p className='footer-new__title footer-new__title--app-links'>{t('Aplikacije')}</p>
          <p className='footer-new__text'>{t('Preuzmi aplikaciju')}:</p>

          <a
            href='https://play.google.com/store/apps/details?id=me.autodiler'
            target='_blank'
            rel='noreferrer'
            aria-label='Google Play'
          >
            <ReactSVG
              src={'/icons/google-play.svg'}
              beforeInjection={svg => {
                svg.classList.add('footer-apps-svg-mobile')
                svg.style.setProperty('width', '120px')
                svg.style.setProperty('margin', '0.5rem 0')
              }}
              wrapper='span'
            />
          </a>

          <a
            href='https://apps.apple.com/us/app/autodiler/id844615689'
            target='_blank'
            rel='noreferrer'
            aria-label='App Store'
          >
            <ReactSVG
              src={'/icons/apple-app-store.svg'}
              beforeInjection={svg => {
                svg.classList.add('footer-apps-svg-mobile')
                svg.classList.add('footer-apps-svg-mobile__app-store')
                svg.style.setProperty('width', '120px')
                svg.style.setProperty('margin', '0.5rem 0')
              }}
              wrapper='span'
            />
          </a>

          <a
            href='https://appgallery.huawei.com/app/C102884519'
            target='_blank'
            rel='noreferrer'
            aria-label='Huawei AppGallery'
          >
            <ReactSVG
              src={'/icons/appgallery.svg'}
              beforeInjection={svg => {
                svg.classList.add('footer-apps-svg-mobile')
                svg.style.setProperty('width', '120px')
                svg.style.setProperty('margin', '0.5rem 0')
              }}
              wrapper='span'
            />
          </a>
        </div>
      </div>

      <div className='footer-new__apps'>
        <a
          href='https://play.google.com/store/apps/details?id=me.autodiler'
          target='_blank'
          rel='noreferrer'
          aria-label='Google Play'
        >
          <ReactSVG
            src={'/icons/google-play.svg'}
            beforeInjection={svg => {
              svg.classList.add('footer-apps-svg-mobile')
              svg.style.setProperty('width', '120px')
            }}
            wrapper='span'
          />
        </a>

        <a
          href='https://apps.apple.com/us/app/autodiler/id844615689'
          target='_blank'
          rel='noreferrer'
          aria-label='App Store'
        >
          <ReactSVG
            src={'/icons/apple-app-store.svg'}
            beforeInjection={svg => {
              svg.classList.add('footer-apps-svg-mobile')
              svg.classList.add('footer-apps-svg-mobile__app-store')
              svg.style.setProperty('width', '110px')
            }}
            wrapper='span'
          />
        </a>

        <a
          href='https://appgallery.huawei.com/app/C102884519'
          target='_blank'
          rel='noreferrer'
          aria-label='Huawei AppGallery'
        >
          <ReactSVG
            src={'/icons/appgallery.svg'}
            beforeInjection={svg => {
              svg.classList.add('footer-apps-svg-mobile')
              svg.style.setProperty('width', '120px')
            }}
            wrapper='span'
          />
        </a>
      </div>

      <div className='footer-new__legal'>
        {/* <p>AutoDiler.me je dio WebLab Grupe.</p>
        <p>Copyright © 2026. Sva prava zadržana.</p> */}

        <Trans
          i18nKey='common:footer_copyright'
          components={{
            p: <p />,
            a: <a target='_blank' href='https://weblab.group/' rel="noreferrer" />,
            br: <br />,
            c: <>&copy;</>
          }}
          defaultTrans='<p>AutoDiler.me je dio <a>WebLab Grupe</a> <br/> Copyright <c/> 2026. Sva prava zadržana.<p>'
        />
      </div>
    </footer>
  )
}

const mapStateToProps = (state) => ({
  groups: getGroups(state),
  userTypes: getUserTypes(state)
})

export default connect(mapStateToProps)(FooterNew)
